import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter} from '@angular/router';
import { routes } from './app/app.routes';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { KeycloakService, KeycloakAngularModule, KeycloakBearerInterceptor } from 'keycloak-angular';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import keycloakConfig from './auth/config/KeycloakConfig';
import { AuthService } from './auth/services/auth.service';



// Initialize Keycloak authentication 
function initializeKeycloak(keycloak: KeycloakService, authService: AuthService) {
  return async () => {
    try {
      await keycloak.init({
        config: keycloakConfig,
        enableBearerInterceptor: true,
        shouldAddToken: () => true,
        authorizationHeaderName: 'Authorization',
        bearerPrefix: 'Bearer',
initOptions: {
  onLoad: 'login-required',
  checkLoginIframe: false 
}
      });
      //  console.log('Keycloak initialized successfully');
     await authService.setUserIdFromToken();
    } catch (error) {
      console.error('Error during initialization:', error);
    }
  };
} 



bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(NoopAnimationsModule),
    provideRouter(routes),
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(KeycloakAngularModule),
 {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, AuthService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    }
  ],
})
  .catch((err) => {
    console.error('Error during application bootstrap:', err);
  });
